import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceViewPaymentsDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-view-payments-dialog-tour',
    name: 'Invoice Payments Tour',
    steps: [
        {
            targetId: 'invoice-view-payments-summary',
            title: 'Invoice and Balance',
            description: 'See the invoice details along with the invoiced amount, total payments made and the amount still due.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-view-payments-add',
            title: 'Add a Payment',
            description: 'Record another payment against this invoice.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-view-payments-grid',
            title: 'Payments Made',
            description: 'Every payment recorded for this invoice. Use the row actions to edit a payment.',
            position: 'top',
        },
    ]
}
